<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router'
import { scrollToTop } from '~/utils'
import { mainMenuTab } from '~/resources/lobby-games/menu-category'
import { BehaviorScrollToTop } from '~/utils/interface'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const { isLighthouseBot } = useLighthouse()

const router = useRouter()
const route = useRoute()
const handleTabChange = (link: string): void => {
  router.push(link)

  scrollToTop(0, BehaviorScrollToTop.SMOOTH, 100)
}

const currentLobbyGameUrl = computed(() => {
  const query = typeof route.query.type === 'string' ? `?type=${route.query.type}` : ''
  return `${route.path}${query}`
})
</script>

<template>
  <div class="main-menu container">
    <div
      v-for="tab in mainMenuTab"
      :key="`tab-${tab.label}`"
      class="menu-tab-item hover-shine"
      :class="{ active: [tab.link, tab.subLink].includes(currentLobbyGameUrl) }"
      @click="handleTabChange(tab.link)"
    >
      <div v-if="!isLighthouseBot" class="icon">
        <img :src="tab.icon ?? ''" :alt="`tab ${tab.label}`" />
      </div>
      <div class="label">{{ tab.label }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/home/main-menu-tab.scss';
</style>
